// src/components/ui/InfoModalTrigger.tsx
import React, { useState } from 'react';
import { Button } from '@/components/ui/button'; // Adjust path as needed
import { Modal } from '@/components/ui/Modal'; // Adjust path as needed
import { HelpCircle } from 'lucide-react'; // Changed from FaQuestionCircle

interface InfoModalTriggerProps {
  modalTitle: string;
  modalContent: React.ReactNode;
  buttonClassName?: string;
  iconSize?: number;
}

export const InfoModalTrigger: React.FC<InfoModalTriggerProps> = ({
  modalTitle,
  modalContent,
  buttonClassName,
  iconSize = 18, // Adjusted default size for Lucide's HelpCircle if needed
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Button
        variant="ghost"
        size="icon"
        onClick={() => setIsModalOpen(true)}
        className={`p-1 h-auto text-gray-500 hover:text-blue-600 hover:bg-blue-50 ${buttonClassName || ''}`}
        aria-label={`More information about ${modalTitle}`}
        title={`More information about ${modalTitle}`}
      >
        <HelpCircle size={iconSize} strokeWidth={2} /> {/* Using Lucide icon */}
      </Button>
      <Modal isOpen={isModalOpen} onOpenChange={setIsModalOpen} title={modalTitle}>
        <div className="p-4 text-sm leading-relaxed">
          {modalContent}
        </div>
      </Modal>
    </>
  );
};